/*
 * Shoreline — Boost grid:
 *   1) show size numbers only (6.5 not 6.5 MEDIUM)
 *   2) move the Loox rating (.boost-sd__product-rating, from Boost's "Show product
 *      rating" + Loox integration) into the image wrapper so shoreline-boost-grid.css
 *      can pin it over the image as the "★ 4.8 (12)" pill — same as the theme cards.
 *      Cards with and without reviews then stay the same height.
 * Loaded on collection/search. Can also paste in Boost app Custom JS.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.boost-sd__filter-product-list';
  var IMAGE_BG_STYLE_ID = 'shoreline-boost-image-bg-fix';
  var LABEL_SELECTOR =
    '.boost-sd__product-swatch-option:not([data-swatch-by="color-and-image"]):not([data-swatch-by="product-image"]) .boost-sd__radio-label, ' +
    '.boost-sd__product-swatch-option[data-swatch-by="text"] .boost-sd__radio-label, ' +
    '.boost-sd__product-swatch-option[data-swatch-by="text"] .boost-sd__button';

  function sizeNumberOnly(value) {
    if (!value) return '';
    var trimmed = String(value).trim();
    var match = trimmed.match(/^(\d+(?:\.\d+)?(?:\/\d+)?)/);
    return match ? match[1] : trimmed.split(/\s+/)[0] || trimmed;
  }

  function shortenLabel(el) {
    if (!el || el.dataset.shorelineSizeShortened === '1') return;

    var full =
      el.getAttribute('data-swatch-value') ||
      el.getAttribute('data-value') ||
      el.textContent ||
      '';
    full = full.trim();
    if (!full || !/^\d/.test(full)) return;

    var shortVal = sizeNumberOnly(full);
    if (!shortVal || shortVal === full) return;

    el.dataset.shorelineSizeFull = full;
    el.dataset.shorelineSizeShortened = '1';
    el.textContent = shortVal;
  }

  function ensureImageBackgroundFix() {
    var existing = document.getElementById(IMAGE_BG_STYLE_ID);
    if (existing) existing.remove();

    var style = document.createElement('style');
    style.id = IMAGE_BG_STYLE_ID;
    style.textContent =
      '.boost-sd__filter-product-list,.boost-sd__filter-product-list .boost-sd__product-item,.template-search .boost-sd__filter-product-list{--boostsd-product-image-background:#ffffff!important}' +
      '.boost-sd__filter-product-list .boost-sd__product-image-wrapper,' +
      '.boost-sd__filter-product-list .boost-sd__product-link-image,' +
      '.boost-sd__filter-product-list .boost-sd__product-image,' +
      '.boost-sd__filter-product-list .boost-sd__product-image-img,' +
      '.boost-sd__filter-product-list .boost-sd__product-image-img--main,' +
      '.boost-sd__filter-product-list .boost-sd__product-image-img--second{background:#ffffff!important;background-color:#ffffff!important}';
    document.head.appendChild(style);
  }

  function pinRating(item) {
    var rating = item.querySelector('.boost-sd__product-rating');
    var wrapper = item.querySelector('.boost-sd__product-image-wrapper');
    if (!rating || !wrapper || rating.parentElement === wrapper) return;
    wrapper.appendChild(rating);
  }

  function process(root) {
    var scope = root && root.querySelector ? root : document;
    var container = scope.querySelector ? scope.querySelector(ROOT_SELECTOR) : null;
    if (!container) return;

    ensureImageBackgroundFix();
    container.querySelectorAll(LABEL_SELECTOR).forEach(shortenLabel);
    container.querySelectorAll('.boost-sd__product-item').forEach(pinRating);
  }

  function initObserver() {
    var container = document.querySelector(ROOT_SELECTOR);
    if (!container || container.dataset.shorelineBoostSizeObserver === '1') return;

    container.dataset.shorelineBoostSizeObserver = '1';
    new MutationObserver(function () {
      process(document);
    }).observe(container, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    process(document);
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  [
    'boost-sd-filter-product-list-rendered',
    'boost-sd-products-rendered',
    'boost-sd-product-list-updated',
    'boost:product:list:updated'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, boot);
  });
})();
